'use strict';
import * as $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError from "./app.data.-Email-Link-Sign-In-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_EmailLinkSignInError$InvalidEmail(providedEmail) {
  this.Y1 = null;
  this.Y1 = providedEmail;
}
export { $c_Lapp_data_EmailLinkSignInError$InvalidEmail as $c_Lapp_data_EmailLinkSignInError$InvalidEmail };
$p = $c_Lapp_data_EmailLinkSignInError$InvalidEmail.prototype = new $j_app$002edata$002e$002dEmail$002dLink$002dSign$002dIn$002dError.$h_Lapp_data_EmailLinkSignInError();
$p.constructor = $c_Lapp_data_EmailLinkSignInError$InvalidEmail;
/** @constructor */
function $h_Lapp_data_EmailLinkSignInError$InvalidEmail() {
}
export { $h_Lapp_data_EmailLinkSignInError$InvalidEmail as $h_Lapp_data_EmailLinkSignInError$InvalidEmail };
$h_Lapp_data_EmailLinkSignInError$InvalidEmail.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_EmailLinkSignInError$InvalidEmail) && (this.Y1 === x$0.Y1)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "InvalidEmail";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y1;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "providedEmail";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_EmailLinkSignInError$InvalidEmail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.js)));
}
export { $isArrayOf_Lapp_data_EmailLinkSignInError$InvalidEmail as $isArrayOf_Lapp_data_EmailLinkSignInError$InvalidEmail };
var $d_Lapp_data_EmailLinkSignInError$InvalidEmail = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_EmailLinkSignInError$InvalidEmail, "app.data.EmailLinkSignInError$InvalidEmail", ({
  js: 1,
  fR: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_EmailLinkSignInError$InvalidEmail as $d_Lapp_data_EmailLinkSignInError$InvalidEmail };
//# sourceMappingURL=app.data.-Email-Link-Sign-In-Error$-Invalid-Email.js.map
